import { defineMessages, type MessageDescriptor } from 'react-intl';

export type RemoteLinkSubtype = 'task' | 'dashboard' | 'invoice' | 'design' | 'deal';

export const messages: Record<RemoteLinkSubtype | string, MessageDescriptor> = defineMessages({
	task: {
		id: 'search-graph-default.task.label',
		defaultMessage: 'Task',
		description: 'A label for remote link work item results.',
	},
	dashboard: {
		id: 'search-graph-default.dashboard.label',
		defaultMessage: 'Dashboard',
		description: 'A label for remote link dashboard results.',
	},
	invoice: {
		id: 'search-graph-default.invoice.label',
		defaultMessage: 'Invoice',
		description: 'A label for remote link invoice results.',
	},
	design: {
		id: 'search-graph-default.design.label',
		defaultMessage: 'Design',
		description: 'A label for remote link design results.',
	},
	deal: {
		id: 'search-graph-default.deal.label',
		defaultMessage: 'Deal',
		description: 'A label for remote link deal results.',
	},
});
